module.exports = __webpack_public_path__ + "img/bg-logo.9673d105.jpg";